{
  "version": "v2",
  "sections": {
    "hero": {
      "label": "Opening",
      "help": "The first thing people see: what you do, for whom, and the one thing to do next.",
      "fields": [
        {
          "key": "headline",
          "label": "Headline",
          "kind": "text",
          "max": 120
        },
        {
          "key": "text",
          "label": "Text",
          "kind": "textarea",
          "max": 400
        },
        {
          "key": "image",
          "label": "Picture",
          "kind": "image"
        },
        {
          "key": "button_label",
          "label": "Button text",
          "kind": "text",
          "max": 40
        }
      ]
    },
    "services": {
      "label": "Services",
      "help": "What you offer, one card each.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "intro",
          "label": "Introduction",
          "kind": "textarea",
          "max": 400
        },
        {
          "key": "items",
          "label": "Services",
          "kind": "list",
          "max_items": 12,
          "item": [
            {
              "key": "title",
              "label": "Name",
              "kind": "text",
              "max": 80
            },
            {
              "key": "text",
              "label": "Description",
              "kind": "textarea",
              "max": 400
            },
            {
              "key": "image",
              "label": "Picture",
              "kind": "image"
            }
          ]
        }
      ]
    },
    "about": {
      "label": "About",
      "help": "Who you are and why customers choose you.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "text",
          "label": "Text",
          "kind": "textarea",
          "max": 2000
        },
        {
          "key": "image",
          "label": "Picture",
          "kind": "image"
        }
      ]
    },
    "proof": {
      "label": "What clients say",
      "help": "Customers' own words. Only real quotes you have permission to use.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "items",
          "label": "Quotes",
          "kind": "list",
          "max_items": 8,
          "item": [
            {
              "key": "quote",
              "label": "Their words",
              "kind": "textarea",
              "max": 400
            },
            {
              "key": "name",
              "label": "Name",
              "kind": "text",
              "max": 80
            },
            {
              "key": "role",
              "label": "Role or firm",
              "kind": "text",
              "max": 80
            }
          ]
        }
      ]
    },
    "faq": {
      "label": "Questions",
      "help": "The questions customers ask before they get in touch.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "items",
          "label": "Questions",
          "kind": "list",
          "max_items": 20,
          "item": [
            {
              "key": "question",
              "label": "Question",
              "kind": "text",
              "max": 200
            },
            {
              "key": "answer",
              "label": "Answer",
              "kind": "textarea",
              "max": 1000
            }
          ]
        }
      ]
    },
    "cta_band": {
      "label": "Call to action",
      "help": "A short band asking people to take the next step.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 120
        },
        {
          "key": "text",
          "label": "Text",
          "kind": "textarea",
          "max": 300
        },
        {
          "key": "button_label",
          "label": "Button text",
          "kind": "text",
          "max": 40
        }
      ]
    },
    "contact": {
      "label": "Contact and enquiry form",
      "help": "Your details, the enquiry form and, if you like, the newsletter sign-up. Bookings follow an enquiry.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "text",
          "label": "Text",
          "kind": "textarea",
          "max": 400
        },
        {
          "key": "phone",
          "label": "Phone",
          "kind": "text",
          "max": 40
        },
        {
          "key": "email",
          "label": "Email",
          "kind": "text",
          "max": 120
        },
        {
          "key": "address",
          "label": "Address",
          "kind": "textarea",
          "max": 300
        },
        {
          "key": "hours",
          "label": "Opening hours",
          "kind": "text",
          "max": 300
        },
        {
          "key": "newsletter",
          "label": "Show the newsletter sign-up",
          "kind": "toggle"
        }
      ]
    },
    "articles": {
      "label": "Articles",
      "help": "Your latest articles from the blog.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "intro",
          "label": "Introduction",
          "kind": "textarea",
          "max": 300
        }
      ]
    },
    "reviews": {
      "label": "Reviews",
      "help": "Your Google reviews, word for word. Only the ones you tick are shown.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "intro",
          "label": "Introduction",
          "kind": "textarea",
          "max": 300
        },
        {
          "key": "reviews",
          "label": "Reviews to show",
          "kind": "reviews",
          "max_items": 12
        }
      ]
    },
    "gallery": {
      "label": "Gallery",
      "help": "Pictures of your work, each with a short caption.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "intro",
          "label": "Introduction",
          "kind": "textarea",
          "max": 300
        },
        {
          "key": "items",
          "label": "Pictures",
          "kind": "list",
          "max_items": 12,
          "item": [
            {
              "key": "image",
              "label": "Picture",
              "kind": "image"
            },
            {
              "key": "caption",
              "label": "Caption",
              "kind": "text",
              "max": 120
            }
          ]
        }
      ]
    },
    "pricing": {
      "label": "Prices",
      "help": "What things cost. Only your own prices: Ogma never guesses them.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "intro",
          "label": "Introduction",
          "kind": "textarea",
          "max": 300
        },
        {
          "key": "items",
          "label": "Prices",
          "kind": "list",
          "max_items": 6,
          "item": [
            {
              "key": "name",
              "label": "Name",
              "kind": "text",
              "max": 80
            },
            {
              "key": "price",
              "label": "Price",
              "kind": "text",
              "max": 40
            },
            {
              "key": "per",
              "label": "Per",
              "kind": "text",
              "max": 40
            },
            {
              "key": "text",
              "label": "What's included",
              "kind": "textarea",
              "max": 400
            },
            {
              "key": "featured",
              "label": "Most popular",
              "kind": "toggle"
            }
          ]
        },
        {
          "key": "note",
          "label": "Small print",
          "kind": "textarea",
          "max": 300
        }
      ]
    },
    "team": {
      "label": "Team",
      "help": "The people customers will meet. A photo of a person needs their consent.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "intro",
          "label": "Introduction",
          "kind": "textarea",
          "max": 400
        },
        {
          "key": "items",
          "label": "People",
          "kind": "list",
          "max_items": 12,
          "item": [
            {
              "key": "name",
              "label": "Name",
              "kind": "text",
              "max": 80
            },
            {
              "key": "role",
              "label": "Role",
              "kind": "text",
              "max": 80
            },
            {
              "key": "text",
              "label": "A line about them",
              "kind": "textarea",
              "max": 400
            },
            {
              "key": "image",
              "label": "Photo",
              "kind": "image"
            }
          ]
        }
      ]
    },
    "areas": {
      "label": "Areas we cover",
      "help": "The towns you work in. A town gets its own page only with real local facts: jobs you have done there, local rules, how quickly you get there.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "intro",
          "label": "Introduction",
          "kind": "textarea",
          "max": 400
        },
        {
          "key": "items",
          "label": "Towns",
          "kind": "list",
          "max_items": 20,
          "item": [
            {
              "key": "town",
              "label": "Town or area",
              "kind": "text",
              "max": 60
            },
            {
              "key": "text",
              "label": "One line for the list",
              "kind": "textarea",
              "max": 300
            },
            {
              "key": "local",
              "label": "Real local facts",
              "kind": "textarea",
              "max": 2000
            },
            {
              "key": "page",
              "label": "Give it its own page",
              "kind": "toggle"
            }
          ]
        }
      ]
    },
    "logos": {
      "label": "Accreditations and clients",
      "help": "Logos of your accreditations, memberships and clients, with their permission, from your pictures.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "items",
          "label": "Logos",
          "kind": "list",
          "max_items": 12,
          "item": [
            {
              "key": "image",
              "label": "Logo",
              "kind": "image"
            },
            {
              "key": "name",
              "label": "Name",
              "kind": "text",
              "max": 80
            }
          ]
        }
      ]
    },
    "steps": {
      "label": "How it works",
      "help": "The steps from the first call to the job done.",
      "fields": [
        {
          "key": "heading",
          "label": "Heading",
          "kind": "text",
          "max": 80
        },
        {
          "key": "intro",
          "label": "Introduction",
          "kind": "textarea",
          "max": 300
        },
        {
          "key": "items",
          "label": "Steps",
          "kind": "list",
          "max_items": 8,
          "item": [
            {
              "key": "title",
              "label": "Step",
              "kind": "text",
              "max": 80
            },
            {
              "key": "text",
              "label": "What happens",
              "kind": "textarea",
              "max": 300
            }
          ]
        }
      ]
    }
  }
}